import { FC, useRef } from 'react';
import { typeHTHHousehold } from '@monorepo/models';

type propsType = {
    currentHousehold: typeHTHHousehold;
    isComplexBuilding: boolean;
    onClickHandler: (currentHousehold: typeHTHHousehold) => void;
};

export const HTHBuildingModalCheckbox: FC<propsType> = ({ currentHousehold, isComplexBuilding, onClickHandler }) => {
    const divClasses = isComplexBuilding ?
        'row d-flex justify-content-start text-center my-2'
        :
        'mt-2 mb-3'
    ;
    const divStyles = isComplexBuilding ?
        { marginInline: '10px', height: '50px', paddingTop: '10px', width: '105px' }
        :
        { marginInline: '5px', minHeight: '50px', width: currentHousehold.isManager ? '132px' : '116px' }
    ;
    const lastClickTsRef = useRef(0);

    const clickHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        const now = e.timeStamp;
        if (now - lastClickTsRef.current < 500) {
            return;
        }
        lastClickTsRef.current = now;
        onClickHandler({ ...currentHousehold, isComplexBuilding });
    }

    const checkbox =
        <input id={`checkbox-${currentHousehold.id}`}
            type={'checkbox'}
            className={`form-check-input checkbox-xs ${currentHousehold.isCheckedNotAnswered ? 'checkbox-yellow' : 'checkbox-red'} pointer`}
            style={{ marginTop: isComplexBuilding ? undefined : '12px' }}
            checked={!!currentHousehold.isChecked || !!currentHousehold.isCheckedNotAnswered}
            onChange={() => {}}
        />
    ;

    return (
        <div className={`bg-dark text-white border rounded pointer ${divClasses}`}
            style={divStyles}
            onClick={clickHandler}
        >
            {isComplexBuilding ?
                <>
                <div className={'col-5'}>
                    {checkbox}
                </div>
                <div className={'col-7'}>
                    <label htmlFor={`checkbox-${currentHousehold.id}`}
                        className={`${currentHousehold.doorName!.length > 5 ?
                            'animate__animated animate__fadeInLeft animate__slow animate__infinite infinite'
                            :
                            ''} pointer`
                        }
                        style={{
                            marginTop: '2px',
                            marginLeft: '5px',
                            overflowX: 'hidden',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {currentHousehold.doorName}
                    </label>
                </div>
                </>
            :
                <div className={'d-flex justify-content-center'}>
                    {checkbox}
                    <label htmlFor={`checkbox-${currentHousehold.id}`}
                        className={'pointer'}
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                    >
                        {currentHousehold.isManager ?
                            'Portería'
                            :
                            currentHousehold.level === 0 ?
                                `PB ${currentHousehold.doorName}`
                                :
                                `${currentHousehold.level}° ${currentHousehold.doorName}`
                        }
                    </label>
                </div>
            }
        </div>
    );
}
